import { useNavigate } from 'react-router-dom';

const services = [
  {
    icon: 'ri-home-heart-line',
    title: 'Interior Painting',
    desc: 'Clean, detailed finishes for walls, ceilings, and trims that transform your living spaces.',
    image: 'https://readdy.ai/api/search-image?query=beautifully%20painted%20modern%20interior%20living%20room%20Wellington%20home%20warm%20neutral%20tones%20cream%20walls%20elegant%20furniture%20natural%20light%20professional%20finish%20clean%20minimalist&width=900&height=620&seq=svc2001&orientation=landscape',
    color: '#F5F0EB',
    accent: '#7A6652',
    tag: '01',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Exterior Painting',
    desc: 'Durable, weather-resistant finishes that protect your home and boost curb appeal.',
    image: 'https://readdy.ai/api/search-image?query=freshly%20painted%20house%20exterior%20Wellington%20New%20Zealand%20white%20walls%20dark%20trim%20professional%20painting%20curb%20appeal%20sunny%20day%20beautiful%20finish%20residential&width=900&height=620&seq=svc2002&orientation=landscape',
    color: '#EEF0EE',
    accent: '#4A6050',
    tag: '02',
  },
  {
    icon: 'ri-home-gear-line',
    title: 'Roof Painting',
    desc: 'Extend the life of your roof with professional coatings and expert application.',
    image: 'https://readdy.ai/api/search-image?query=professional%20roof%20painting%20New%20Zealand%20residential%20home%20clean%20coated%20roof%20tiles%20dark%20charcoal%20colour%20professional%20finish%20sunny%20day%20Wellington&width=900&height=620&seq=svc2003&orientation=landscape',
    color: '#EDEEF2',
    accent: '#4A5068',
    tag: '03',
  },
  {
    icon: 'ri-magic-line',
    title: 'Fine Finish Spraying',
    desc: 'High-end, flawlessly smooth finishes using advanced spray technology.',
    image: 'https://readdy.ai/api/search-image?query=professional%20spray%20painting%20fine%20finish%20cabinetry%20kitchen%20doors%20smooth%20flawless%20white%20surface%20premium%20quality%20spray%20booth%20clean%20result&width=900&height=620&seq=svc2004&orientation=landscape',
    color: '#F2EEEC',
    accent: '#6B4F45',
    tag: '04',
  },
  {
    icon: 'ri-tools-line',
    title: 'Plastering & Gib Stopping',
    desc: 'Perfect surface preparation for premium, long-lasting results every time.',
    image: 'https://static.readdy.ai/image/38235d25ca124ed59b2cbc0dcd639844/2390fe6fe88e31164052364ecbfe2816.jpeg',
    color: '#EFEFEF',
    accent: '#555555',
    tag: '05',
  },
  {
    icon: 'ri-drop-line',
    title: 'House Washing',
    desc: 'Exterior cleaning using water blasting and soft wash methods for a like-new look.',
    image: 'https://readdy.ai/api/search-image?query=professional%20house%20washing%20water%20blasting%20exterior%20home%20cleaning%20Wellington%20New%20Zealand%20clean%20bright%20white%20walls%20pressure%20washing%20residential%20property&width=900&height=620&seq=svc2006&orientation=landscape',
    color: '#EBF0F2',
    accent: '#3D5F6B',
    tag: '06',
  },
];

export default function ServicesOverview() {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="inline-block text-sm font-bold tracking-widest uppercase mb-4 text-gray-400">
              What We Do
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 tracking-tight leading-none">
              Our<br />Services
            </h2>
            <p className="text-gray-500 mt-5 max-w-lg text-base leading-relaxed">
              Complete painting and decorating solutions for homes and businesses across Wellington &amp; Hutt Valley.
            </p>
          </div>
          <a
            href="/services"
            onClick={(e) => { e.preventDefault(); navigate('/services'); }}
            className="flex-shrink-0 inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-bold rounded-full whitespace-nowrap hover:bg-gray-700 transition-all cursor-pointer text-sm tracking-wide"
          >
            Explore All Services <i className="ri-arrow-right-line text-base" />
          </a>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <div
              key={service.title}
              className="group cursor-pointer rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300"
              style={{ backgroundColor: service.color }}
              onClick={() => navigate('/services')}
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  {/* Icon */}
                  <div
                    className="w-11 h-11 flex items-center justify-center rounded-xl"
                    style={{ backgroundColor: service.accent }}
                  >
                    <i className={`${service.icon} text-white text-xl`} />
                  </div>
                  {/* Tag number */}
                  <span
                    className="text-xs font-black tracking-widest px-3 py-1 rounded-full"
                    style={{ backgroundColor: `${service.accent}18`, color: service.accent }}
                  >
                    {service.tag}
                  </span>
                </div>

                <h3 className="font-black text-xl text-gray-900 mb-2 tracking-tight">{service.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{service.desc}</p>

                <div
                  className="inline-flex items-center gap-1.5 text-sm font-bold group-hover:gap-3 transition-all"
                  style={{ color: service.accent }}
                >
                  Get a Quote <i className="ri-arrow-right-line" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
